"use strict";

var Tooltip = require("app/shared/components/Tooltip/tooltip");

var NumberPicker = React.createClass({
  propTypes: {
    maxValue: React.PropTypes.number.isRequired,
    minValue: React.PropTypes.number,
    selectedValue: React.PropTypes.number,
    handlePick: React.PropTypes.func
  },
  getDefaultProps:function () {
    return {
      minValue: 0,
      selectedValue: 0,
      handlePick: undefined
    };
  },
  handleChange: function(event) {
    var value = event.target.value;
    this.onPick(parseInt(value));
  },
  addNumber: function() {
    this.onPick(this.props.selectedValue + 1);
  },
  subtractNumber: function() {
    this.onPick(this.props.selectedValue - 1);
  },
  onPick: function (selectedValue) {
    if (this.inRange(selectedValue)) {
      this.callHandlePick(parseInt(selectedValue));
    } else if (selectedValue === "") {
      this.callHandlePick(this.props.minValue);
    }
  },
  inRange: function (selectedValue) {
    return selectedValue >= this.props.minValue && selectedValue <= this.props.maxValue;
  },
  callHandlePick: function(value){
    if (this.props.handlePick != undefined) {
      this.props.handlePick(value);
    }
  },
  getValue: function () {
    if (this.props.selectedValue === 0 && this.props.minValue > 0) {
      return "";
    } else {
      return this.props.selectedValue;
    }
  },
  render: function() {
    return (
      <div className="bootstrap-agendor">
        <div className="numberPicker">
          <div ref="decrement-button" className="numberPicker-arrowButton f-l c-pointer" onClick={this.subtractNumber}>
            <div className="numberPicker-arrow numberPicker-arrow--left">-</div>
          </div>
          <input type="text" ref="input-number" className="numberPicker-number"
            value={this.getValue()} onChange={this.handleChange}/>
          <div ref="increment-button" className="numberPicker-arrowButton f-r c-pointer"
            onClick={this.addNumber}>
            <div className="numberPicker-arrow numberPicker-arrow--right">+</div>
          </div>
        </div>
      </div>
    );
  }
});

module.exports = NumberPicker;



// WEBPACK FOOTER //
// ./app/shared/components/NumberPicker/number-picker.jsx